import React from 'react';

function RegistrationCard({ student, index, onChange, onBlur ,downloadSingleGradeCard}) {
  // Helper to determine if a field is empty
  const isEmpty = (val) => !val || val.trim() === "";

  return (
    <div className="w-full">
      {/* Grid on wide screens, vertical on small */}
      <div className="grid max-[899px]:flex max-[899px]:flex-col grid-cols-[.5fr_6fr_6fr_6fr_1.5fr_6fr_2.5fr_2fr] gap-1 items-start w-full border p-1 rounded bg-gray-50">
        
        {/* Serial No */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600 text-transparent">Sl</label>
          <p className="text-xs p-1 text-center">{index + 1}</p>
        </div>

        {/* Name */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Name</label>
          <input
            type="text"
            value={student.name}
            className={`w-full border-b-2 border-gray-200 hover:border-blue-600 focus:border-red-700 focus:outline-none transition-colors duration-300 ${
              isEmpty(student.name) ? "bg-red-300" : ""
            }`}
            onChange={(e) => onChange(student._id, "name", e.target.value)}
            onBlur={(e) => onBlur(student._id, "name", e.target.value)}
          />
        </div>

        {/* Father's Name */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Father's Name</label>
          <input
            type="text"
            value={student.father_name}
            className={`w-full border-b-2 border-gray-200 hover:border-blue-600 focus:border-red-700 focus:outline-none transition-colors duration-300 ${
              isEmpty(student.father_name) ? "bg-red-300" : ""
            }`}
            onChange={(e) => onChange(student._id, "father_name", e.target.value)}
            onBlur={(e) => onBlur(student._id, "father_name", e.target.value)}
          />
        </div>

        {/* Mother's Name */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Mother's Name</label>
          <input
            type="text"
            value={student.mother_name}
            className={`w-full border-b-2 border-gray-200 hover:border-blue-600 focus:border-red-700 focus:outline-none transition-colors duration-300 ${
              isEmpty(student.mother_name) ? "bg-red-300" : ""
            }`}
            onChange={(e) => onChange(student._id, "mother_name", e.target.value)}
            onBlur={(e) => onBlur(student._id, "mother_name", e.target.value)}
          />
        </div>


        {/* Issue Date */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Issue Date</label>
          <input
            type="date"
            value={student.issue_date}
            className={`w-full border-b-2 border-gray-200 hover:border-blue-600 focus:border-red-700 focus:outline-none transition-colors duration-300 ${
              isEmpty(student.issue_date) ? "bg-red-300" : ""
            }`}
            onChange={(e) => onChange(student._id, "issue_date", e.target.value)}
            onBlur={(e) => onBlur(student._id, "issue_date", e.target.value)}
          />
        </div>


        {/* Institute Name */}
        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Institute</label>
          <p className="text-sm">{student.institute_name}</p>
        </div>

        <div className="flex flex-col w-full">
          <label className="text-xs text-gray-600">Reg No</label>
          <p className="text-sm">{student.registration_number}</p>
        </div>


        {/* Download Button */}
        <div className="flex flex-col">
          <label className="text-xs text-gray-600">Action</label>
          <button onClick={(e)=>downloadSingleGradeCard(student._id,student.registration_number)} className="bg-blue-500 text-white rounded px-2 py-1 text-xs hover:bg-blue-600">
            Download
          </button>
        </div>
      </div>
    </div>
  );
}

export default RegistrationCard;
